<template>
  <div class="box">
    {{text}}
  </div>
</template>

<script>
export default {
  name: "TestConfirmTips",
  props: {
    text: {type: String, default: '如果明白請按「確定」'}
  }
}
</script>

<style scoped>
  .box{
    text-align: center;
    font-size: var(--ecs-font-md);
    color: #61005f;
  }
</style>
